/* De meting van de ingang naar Mijn Vijver (routingplan: vijvercentrum-plus docs/mijn-vijver/routing-vijverprofiel.md).
   Bij een klik op een link met data-vp-ingang stuurt dit script de GA4-gebeurtenis vp_mijn_vijver_klik via de
   gtag van het thema (property 377865496). Alleen na toestemming voor analytics, nooit bij Global Privacy
   Control en nooit in de editor; dezelfde regel als assets/product-community-questions.js en het blok vp-profiel.
   Parameters: vp_bron (waar de klik vandaan kwam), vp_deel (het onderdeel of 'overzicht'), vp_ingelogd
   ('ja' of 'nee') en vp_versie. Geen klant-id, geen e-mail, geen querystring, geen opslag, geen eigen netwerk.
   Zonder JavaScript werkt de link gewoon; de meting valt dan weg. */
(function (g) {
  'use strict';
  var VERSIE = 'ingang-1';
  var BRON = /^[a-z0-9][a-z0-9_-]{0,39}$/;
  var DELEN = {profiel: true, apparatuur: true, onderhoud: true, metingen: true, plus: true};

  function toestemming() {
    if (g.navigator && g.navigator.globalPrivacyControl === true) return false;
    if (g.Shopify && g.Shopify.designMode) return false;
    var cp = g.Shopify && g.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() === true;
    return false;
  }

  function gegevens(el) {
    var bron = el.getAttribute('data-vp-ingang') || '';
    var deel = el.getAttribute('data-vp-deel') || '';
    return {
      vp_bron: BRON.test(bron) ? bron : 'onbekend',
      vp_deel: Object.prototype.hasOwnProperty.call(DELEN, deel) ? deel : 'overzicht',
      vp_ingelogd: el.getAttribute('data-vp-ingelogd') === 'ja' ? 'ja' : 'nee',
      vp_versie: VERSIE
    };
  }

  function klik(e) {
    var doel = e && e.target;
    var el = doel && typeof doel.closest === 'function' ? doel.closest('[data-vp-ingang]') : null;
    if (!el || !toestemming() || typeof g.gtag !== 'function') return false;
    var p = gegevens(el);
    p.transport_type = 'beacon';
    try { g.gtag('event', 'vp_mijn_vijver_klik', p); return true; } catch (x) { return false; }
  }

  g.VPIngang = {versie: VERSIE, toestemming: toestemming, gegevens: gegevens, klik: klik};
  // Een luisteraar op het document: werkt ook voor het mobiele menu en voor secties die later laden.
  if (g.document && typeof g.document.addEventListener === 'function') g.document.addEventListener('click', klik, true);
})(typeof window !== 'undefined' ? window : this);
